module.exports = __webpack_public_path__ + "img/PC7.c1e24793.png";